import { cssifyMediaQueryRules, objectReduce } from 'fela-utils';

export default function renderToString(renderer) {
  var basicCSS = renderer.fontFaces + renderer.statics + renderer.keyframes + renderer.rules;

  return objectReduce(renderer.mediaRules, function (css, rules, query) {
    return css + cssifyMediaQueryRules(query, rules);
  }, basicCSS);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-tools/es/renderToString.js
// module id = 261
// module chunks = 0